import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { GallerySection } from '../components/GallerySection';
import { EmotionalLead } from '../components/EmotionalLead';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel(pixelId: string) {
  if (window.fbq) return;
  const n: any = window.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', pixelId);
}
export function SalesPage() {
  useEffect(() => {
    initMetaPixel('3934337213376403');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-273">
      <AnnouncementBar data-id="element-274" />
      <HeroSection data-id="element-275" />
      <GallerySection data-id="element-276" />
      <EmotionalLead data-id="element-277" />
      <UniqueMechanism data-id="element-278" />
      <BenefitsSection data-id="element-279" />
      <TestimonialsSection data-id="element-280" />
      <OfferSection data-id="element-281" />
      <GuaranteeSection data-id="element-282" />
      <UrgencySection data-id="element-283" />
      <FAQSection data-id="element-284" />
      <EmotionalClose data-id="element-285" />
      <Footer data-id="element-286" />
    </div>;
}